<template>

<v-card>
  <v-toolbar   height="42"    color="#4A76A8" dark flat> <v-card-title>Условия выполнения действия</v-card-title> <v-spacer></v-spacer> <v-icon @click="close()">mdi-close</v-icon>  </v-toolbar>
<v-card-text  >




<div v-if="conditions.type == 'pages'">
   <v-checkbox label="Игноририровать условия если  аккаунт закрыт? (действие будет выполнено если есть такая возможность)" > </v-checkbox>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.follMin !== undefined" v-model="conditions.cond.follMin" label="Подписчиков не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.follMax !== undefined" v-model="conditions.cond.follMax" label="Подписчиков не более чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.frMin !== undefined" v-model="conditions.cond.frMin" label="Друзей не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.frMax !== undefined" v-model="conditions.cond.frMax" label="Друзей не более чем">  </v-text-field>

<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.avatarLikesMin !== undefined" v-model="conditions.cond.avatarLikesMin" label="Лайков не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.avatarLikesMax !== undefined " v-model="conditions.cond.avatarLikesMax" label="Лайков не более чем">  </v-text-field>

<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.ageMin !== undefined" v-model="conditions.cond.ageMin" label="Возраст не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.ageMax !== undefined " v-model="conditions.cond.ageMax" label="Возраст не более чем">  </v-text-field>




<v-select
  color="#4A76A8"
  v-model="conditions.cond.sex"
  :items="pages.sex.options"
  v-bind='[{label:pages.sex.name} ]'
></v-select>

<v-checkbox v-if="conditions.cond.noMsg !== undefined "  v-model="conditions.cond.noMsg"  label="Если нельзя отправить сообщение"> </v-checkbox>
 <v-checkbox v-model="conditions.cond.online"  label="только онлайн"> </v-checkbox>
 <v-checkbox v-model="conditions.activated"  label="Активировать условия"> </v-checkbox>



</div>








<div v-if="conditions.type == 'groups'">

<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.follMin !== undefined" v-model="conditions.cond.follMin" label="Участников не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.follMax !== undefined" v-model="conditions.cond.follMax" label="Участников не более чем">  </v-text-field>


<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.topicsMin !== undefined" v-model="conditions.cond.topicsMin" label="Обсуждений не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.topicsMax !== undefined" v-model="conditions.cond.topicsMax" label="Обсуждений не более чем">  </v-text-field>
 <v-checkbox v-model="conditions.activated"  label="Активировать условия"> </v-checkbox>


</div>


<div v-if="conditions.type == 'content'">

<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.commentsMax !== undefined" v-model="conditions.cond.commentsMax" label="Комментариев не более чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.commentsMin !== undefined" v-model="conditions.cond.commentsMin" label="Комментариев не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.likesMin !== undefined" v-model="conditions.cond.likesMin" label="Лайков не менее чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.likesMax !== undefined" v-model="conditions.cond.likesMax" label="Лайков не более чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.viewMax !== undefined" v-model="conditions.cond.viewMax" label="Просмотров не более чем">  </v-text-field>
<v-text-field clearable color="#4A76A8"  v-if="conditions.cond.viewMin !== undefined" v-model="conditions.cond.viewMin" label="Просмотров не менее чем">  </v-text-field>
 <v-checkbox v-model="conditions.activated"  label="Активировать условия"> </v-checkbox>


</div>



















</v-card-text>



<v-card-actions>
<v-spacer></v-spacer>
<v-btn @click="close()" small flat color="#4A76A8">Отменить</v-btn>  <v-btn  @click="conditionSave()" small color="#4A76A8"  class="white--text" > Сохранить</v-btn>
</v-card-actions>


</v-card>


</template>

<script>


export default {
props:['conditions' ],
components:{},
  data () {
    return {
  pages:{
    sex:  {
        name: 'Выберите пол',
        options: [{text:'Любой',value:''},{text:'Мужской',value:'2'},{text:'Женский',value:'1'}],

      },

  },
  groups: {},
  content: {},

    }
  },

  computed : {

  },
  methods : {
    conditionSave(){
       this.conditions.modal = false
    },
    close: function(){
      this.conditions.modal = false
      this.conditions.activated = false
    },
  }
}
</script>

<style  >

</style>
